import axios from "axios";

const url_api = import.meta.env.VITE_URL_API

export const client = axios.create({ baseURL: url_api, withCredentials: true });
